import PenconnectInc from './PenconnectInc';
import Admin from './Admin';
import './index.css';

export default function App() {
  const isAdmin = new URLSearchParams(window.location.search).get('admin') === '1';
  return isAdmin ? <Admin /> : <PenconnectInc />;
}
